var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTickWhite = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5429 5.79346C19.6092 5.79346 19.6728 5.81982 19.7197 5.8667L21.1337 7.28076C21.2314 7.37838 21.2313 7.53664 21.1337 7.63428L10.6337 18.1343C10.1761 18.5917 9.45178 18.6205 8.96089 18.2202L8.86617 18.1343L3.61617 12.8843C3.51864 12.7866 3.51857 12.6284 3.61617 12.5308L5.03023 11.1167L5.06831 11.0854C5.10907 11.0583 5.15727 11.0435 5.20699 11.0435C5.27328 11.0435 5.33686 11.0698 5.38374 11.1167L9.74898 15.4819L19.3662 5.8667L19.4043 5.83545C19.445 5.80828 19.4932 5.79346 19.5429 5.79346Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTickWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TickWhite.f340d7f7.svg";
export { ForwardRef as ReactComponent };